import {global} from './lib/utils/globals';
global.probe = {};
